import { _ as _toConsumableArray } from './built-js.cookie-41e8f601.js';
import { V as Vue } from './built-vue.esm-661ab646.js';
import './built-swiper.esm-8d485866.js';
import { i as init } from './built-carousel-swiper-5a02e8e0.js';

Vue.config.errorHandler = function (err, vm, info) {
  var cart = CartJS.cart || window.vars.cartPayload;
  var logCart = {
    attributes: cart.attributes,
    item_count: cart.item_count,
    token: cart.token,
    items: cart.items.map(function (item) {
      return {
        title: item.title,
        handle: item.handle,
        product_id: item.product_id,
        variant_id: item.variant_id,
        variant_options: item.variant_options,
        url: item.url
      };
    })
  };
  console.log('Vue error', err);
  Rollbar.error("Vue error", {
    'err': err,
    'cart': JSON.stringify(logCart)
  }, function (err, data) {
    if (err) {
      console.log("Error while reporting error to Rollbar: ", err);
    } else {
      console.log("Error successfully reported to Rollbar. UUID:", data.result.uuid);
    }
  });

  if (window.location.pathname === '/cart') {
    console.log({
      'event': 'cart_clear',
      'cart': CartJS.cart || window.vars.cartPayload,
      'err': err,
      'vm': vm,
      'info': info
    });
    Rollbar.error("Cart clear triggered", {
      'cart': JSON.stringify(logCart),
      'err': err,
      'vm': vm,
      'info': info
    }, function (err, data) {
      if (err) {
        console.log("Error while reporting error to Rollbar: ", err);
      } else {
        console.log("Error successfully reported to Rollbar. UUID:", data.result.uuid);
      }

      CartJS.clear({
        success: function success() {
          window.location.reload();
        }
      });
    });
  }
};

window.vars.tomItLoaded = 0;

function removeFromString(arr, str) {
  var regex = new RegExp("\\b" + arr.join('|') + "\\b", "gi");
  return str.replace(regex, '');
}

window.translations = window.translations || {};
var deliveryWindow = 'product_availability' in window.translations ? window.translations['product_availability']['delivery_duration'] : '2-6 day delivery in Metro areas';
var cartInit = false;
var invInit = false;
var storesSort = window.masterStores.map(function (a) {
  return a.name;
});

var emptyLoc = function emptyLoc(name) {
  var empty = {
    available: 0,
    distance: 0,
    id: "0",
    inStock: 0,
    name: name,
    pickupOption: false
  };
  return empty;
};

var emptyInventoryItem = window.masterStores.map(function (store) {
  return emptyLoc(store.name);
});
var emptyDelivery = {
  name: 'Delivery',
  ready: 'Unavailable for delivery',
  available: 0,
  inStock: 0,
  availability: {
    class: 'out',
    text: 'Out of Stock'
  },
  hours: deliveryWindow
};

function addMasterStoresData(inventoryItem, item) {
  inventoryItem.locations = inventoryItem.locations.filter(function (loc) {
    return storesSort.indexOf(loc.name) !== -1;
  });
  var locs = inventoryItem.locations;
  var onlineInventoryLocs = locs.filter(function (loc) {
    return window.onlineInventoryStores.indexOf(loc.name) !== -1;
  });
  var onlineInventoryItem; // console.log('onlineInventoryLocs', onlineInventoryLocs);

  if (onlineInventoryLocs.length > 0) {
    var totalAvailable = onlineInventoryLocs.map(function (loc) {
      return loc.available;
    }).reduce(function (a, b) {
      return +a + +b;
    }, 0);
    onlineInventoryItem = {
      name: 'Delivery',
      available: totalAvailable,
      inStock: totalAvailable > 0 ? 1 : 0,
      hours: deliveryWindow,
      availability: {
        class: totalAvailable > 2 ? 'in' : totalAvailable > 0 ? 'low' : 'out',
        text: totalAvailable > 2 ? 'In Stock' : totalAvailable > 0 ? 'Low Stock' : 'Out of Stock'
      },
      ready: totalAvailable > 0 ? 'Available for delivery' : 'Unavailable for delivery'
    };
  } else {
    onlineInventoryItem = {
      name: 'Delivery',
      ready: 'Unavailable for delivery',
      available: 0,
      inStock: 0,
      availability: {
        class: 'out',
        text: 'Out of Stock'
      },
      hours: deliveryWindow
    };
  }

  inventoryItem.delivery = onlineInventoryItem;
  console.log(inventoryItem, item);
  var duplicateStores = window.masterStores.filter(function (loc) {
    return loc.duplicate;
  });
  duplicateStores.forEach(function (loc) {
    var alreadyAdded = inventoryItem.locations.find(function (obj) {
      return obj.name === loc.name;
    });

    if (!alreadyAdded) {
      var thisLoc = inventoryItem.locations.find(function (obj) {
        return obj.name === loc.duplicate;
      });

      if (thisLoc && (thisLoc.name !== 'Genesis' || item.grams <= 22000)) {
        var duplicateLoc = JSON.parse(JSON.stringify(thisLoc));
        duplicateLoc.name = loc.name;
        inventoryItem.locations.push(duplicateLoc);
      }
    }
  });

  var _loop = function _loop() {
    var masterLoc = window.masterStores[i];
    var alreadyAdded = inventoryItem.locations.find(function (obj) {
      return obj.name === masterLoc.name;
    });

    if (!alreadyAdded) {
      inventoryItem.locations.push(emptyLoc(masterLoc.name));
    } else {
      var productTags = item.tags;
      var tag_exclusion_1 = masterLoc.tag_exclusion_1,
          tag_exclusion_message_1 = masterLoc.tag_exclusion_message_1,
          tag_exclusion_2 = masterLoc.tag_exclusion_2,
          tag_exclusion_message_2 = masterLoc.tag_exclusion_message_2,
          tag_exclusion_3 = masterLoc.tag_exclusion_3,
          tag_exclusion_message_3 = masterLoc.tag_exclusion_message_3,
          tag_exclusion_4 = masterLoc.tag_exclusion_4,
          tag_exclusion_message_4 = masterLoc.tag_exclusion_message_4,
          tag_exclusion_5 = masterLoc.tag_exclusion_5,
          tag_exclusion_message_5 = masterLoc.tag_exclusion_message_5;
      var tagExclusions = [tag_exclusion_1, tag_exclusion_2, tag_exclusion_3, tag_exclusion_4, tag_exclusion_5];
      var tagExclusionMessages = [tag_exclusion_message_1, tag_exclusion_message_2, tag_exclusion_message_3, tag_exclusion_message_4, tag_exclusion_message_5];
      console.log(item, productTags);
      var excludedTag = tagExclusions.findIndex(function (tag) {
        return productTags.indexOf(tag) !== -1;
      });

      if (excludedTag !== -1) {
        alreadyAdded.available = 0;
        alreadyAdded.inStock = 0;
        alreadyAdded.q = 0;
      }

      var excludedMessage = tagExclusionMessages[excludedTag];
      alreadyAdded.excludedMessage = excludedMessage;
    }
  };

  for (var i = window.masterStores.length - 1; i >= 0; i--) {
    _loop();
  } //inventoryItem.locations = inventoryItem.locations.filter(loc => window.ccStores.indexOf(loc.name) !== -1);

}

function supplementCart(cart) {
  // console.log('supplementCart', cart, invInit);
  cart.items.forEach(function (item) {
    item.tags = window.vars.productTags[item.product_id];
  });

  for (var i = cart.items.length - 1; i >= 0; i--) {
    var item = cart.items[i];

    if (invInit[item.product_id] && invInit[item.product_id].product.variants[item.variant_id]) {
      var invItem = invInit[item.product_id].product.variants[item.variant_id].inventoryItem;
      addMasterStoresData(invItem, item);
      item.delivery = invItem.delivery;
      item.locations = invItem.locations;
    } else {
      console.log(i, 'No locations info for ' + item.title);
      Rollbar.warning("Empty Inventory Item assigned", {
        'title': item.title,
        'product_id': item.product_id,
        'variant_id': item.variant_id,
        'url': item.url
      });
      item.locations = JSON.parse(JSON.stringify(emptyInventoryItem));
      item.delivery = emptyDelivery;
    }
  } // console.log('supplementCart', cart, invInit)


  return cart;
}
/**
 * Attach listeners to open collapse elements
 */


var initCartDisplay = function initCartDisplay(cart) {
  var _ref = window.vars || {},
      favStore = _ref.favStore,
      deliveryOption = _ref.deliveryOption; // console.log(favStore)


  CartJS.setAttributes({
    'delivery_mode': window.clickCollectVersion === 'v1' ? deliveryOption : 'Delivery',
    'pickup_location': window.clickCollectVersion === 'v1' && deliveryOption !== 'Delivery' ? favStore == null ? void 0 : favStore.street1 : 'none',
    'pickup_confirmation_message': window.clickCollectVersion === 'v1' && (favStore == null ? void 0 : favStore['email_confirmation_message']) ? favStore['email_confirmation_message'] : ''
  }, {
    'error': function error() {
      location.reload();
    }
  });
  console.log('initCartDisplay');
  console.log('cart', cart);

  try {
    console.log('window.vars.tomItLoaded', window.vars.tomItLoaded);

    if (window.vars.tomItLoaded == 1) {
      window.cartDisplay = new Vue({
        el: '#cartDisplay',
        data: {
          componentKey: 0,
          cart: supplementCart(JSON.parse(JSON.stringify(cart))),
          masterStores: window.masterStores,
          pickupStores: window.masterStores.filter(function (loc) {
            return window.ccStores.indexOf(loc.name) !== -1;
          }),
          favStore: window.vars.favStore || {},
          deliveryOption: window.vars.deliveryOption,
          override: false,
          spinnerLoader: window.spinnerLoaderUrl,
          maxQtyResetMessage: window.maxQtyResetMessage,
          maxQtyResetDuration: window.maxQtyResetDuration * 1000,
          resettingCartItem: null
        },
        methods: {
          forceRerender: function forceRerender() {
            this.componentKey += 1;
          },
          changeWholeData: function changeWholeData(newData, part) {
            var changeData = part ? this.$data[part] : this.$data;
            Object.keys(changeData).forEach(function (key) {
              return changeData[key] = null;
            });
            Object.entries(newData).forEach(function (entry) {
              return Vue.set(changeData, entry[0], entry[1]);
            });

            if (this.$data.override) {
              // TODO: Remove timeout and lock onto re-render
              setTimeout(function () {
                jQuery('.checkout-btn').click();
              }, 300);
            }
          },
          money: function money(price) {
            return "$" + (price / 100).toFixed(2);
          },
          updateQuantity: function updateQuantity(lineIndex, newQty, item) {
            var currentMax = this.currentMax(item);
            var vueCartThis = this; // console.log('updateQuantity');
            // console.log(lineIndex, newQty, item, currentMax, this);

            if (+newQty > +currentMax) {
              this.resettingCartItem = lineIndex;
              window.setTimeout(function () {
                item.quantity = +currentMax;
                CartJS.updateItem(lineIndex, +currentMax);
                vueCartThis.resettingCartItem = null;
              }, this.maxQtyResetDuration);
            } else {
              CartJS.updateItem(lineIndex, newQty);
            }
          },
          setFavStore: function setFavStore(event) {
            console.log('setFavStore');
            var masterStore = window.masterStores.find(function (obj) {
              return obj.id === event.target.value;
            });

            if (masterStore) {
              localStorage.setItem('favoritedStore', JSON.stringify(masterStore));
              window.vars.favStore = JSON.parse(localStorage.getItem('favoritedStore'));
              this.changeWholeData(window.vars.favStore, 'favStore'); // localStorage.setItem('deliveryOption', 'Click & Collect');
              // window.vars.deliveryOption =
              //   localStorage.getItem('deliveryOption') || 'Delivery';
              // this.$data.deliveryOption = window.vars.deliveryOption;

              this.setDeliveryOption(undefined, 'Click & Collect');
            }
          },
          setDeliveryOption: function setDeliveryOption(event, valueOverride) {
            var _app$favStore, _app$favStore2;

            console.log('setDeliveryOption');
            var app = this;
            localStorage.setItem('deliveryOption', event ? event.target.value : valueOverride);
            window.vars.deliveryOption = localStorage.getItem('deliveryOption') || 'Delivery';
            this.$data.deliveryOption = window.vars.deliveryOption;
            var checkoutBtn = jQuery('[name="checkout"]');
            checkoutBtn.prop('disabled', true); // console.log(app.favStore)
            // console.log(app.favStore?.['email_confirmation_message'] ? app.favStore['email_confirmation_messaage'] : '');

            CartJS.setAttributes({
              'delivery_mode': window.vars.deliveryOption,
              'pickup_location': app.deliveryOption !== 'Delivery' ? (_app$favStore = app.favStore) == null ? void 0 : _app$favStore.street1 : 'none',
              'pickup_confirmation_message': ((_app$favStore2 = app.favStore) == null ? void 0 : _app$favStore2['email_confirmation_message']) ? app.favStore['email_confirmation_message'] : ''
            }, {
              'success': function success() {
                checkoutBtn.prop('disabled', false);
              },
              'error': function error() {
                location.reload();
              }
            });
          },
          checkAvailability: function checkAvailability(item) {
            var app = this;

            if (!item.locations) {
              return 'out';
            }

            var checkLoc = item.delivery;

            if (app.deliveryOption !== 'Delivery') {
              checkLoc = item.locations.find(function (obj) {
                return obj.name === app.favStore.name;
              });
            } // We only support overselling for delivery only


            if (app.deliveryOption === 'Delivery' && checkLoc.inStock === 0) {
              checkLoc.inStock = this.checkIfItemIsAllowedToOversell(item.id) > 0 || this.checkIfItemIsNonInventory(item);
            } // Only allow gift cards to be checked out if delivery option is delivery


            if (app.deliveryOption !== 'Delivery' && item.gift_card) return 'out';
            return checkLoc.inStock > 0 ? 'in' : 'out';
          },
          filterInvalidKeywords: function filterInvalidKeywords(title) {
            var invalidKeywords = window.vars.ecoHideContent['eco_hide_strings'] || [];
            var filteredTitle = removeFromString(invalidKeywords, title);
            return filteredTitle;
          },
          currentMax: function currentMax(item) {
            // Let availabilities = item.locations.map(a => a.available);
            // return Math.max(checkLoc);
            var app = this;
            var checkLoc = item.delivery; // console.log('currentMax 2', checkLoc, app, this.checkIfItemIsAllowedToOversell(item.id), this.checkIfItemIsNonInventory(item))

            if (app.deliveryOption !== 'Delivery') {
              checkLoc = item.locations.find(function (obj) {
                return obj.name === app.favStore.name;
              });
            } // We only support overselling for delivery only


            if (app.deliveryOption === 'Delivery' && checkLoc.available === 0) {
              checkLoc.available = this.checkIfItemIsAllowedToOversell(item.id) || this.checkIfItemIsNonInventory(item);
            } // Only allow gift cards to be checked out if delivery option is delivery


            if (app.deliveryOption !== 'Delivery' && item.gift_card) return 0;
            return checkLoc.available;
          },
          deliveryMax: function deliveryMax(item) {
            // Let availabilities = item.locations.map(a => a.available);
            // return Math.max(checkLoc);
            var app = this;
            var checkLoc = item.delivery;
            console.log('Delivery', checkLoc.available);
            return checkLoc.available;
          },
          favStoreMax: function favStoreMax(item) {
            // Let availabilities = item.locations.map(a => a.available);
            // return Math.max(checkLoc);
            var app = this;
            var checkLoc = item.locations.find(function (obj) {
              return obj.name === app.favStore.name;
            });
            console.log('favStore', checkLoc.available);
            return checkLoc ? checkLoc.available : 0;
          },

          /**
           * Check if the cart item's variant is allowed to oversell
           * 
           * @param {number} itemId 
           * @returns {number} Returns available quantity if it is allowed to oversell. Otherwise, return 0
           */
          checkIfItemIsAllowedToOversell: function checkIfItemIsAllowedToOversell(itemId) {
            var _window$itemsWithVari = window.itemsWithVariantInventoryData.find(function (_ref2) {
              var id = _ref2.id;
              return id === itemId;
            }),
                variant = _window$itemsWithVari.variant,
                productOversellThreshold = _window$itemsWithVari.productOversellThreshold;

            var oversellThreshold = productOversellThreshold * -1;
            var inventoryQuantity = variant ? variant.inventory_quantity : undefined;
            var inventoryPolicy = variant ? variant.inventory_policy : undefined;
            var variantIsAllowedToOversell = inventoryPolicy === 'continue' && inventoryQuantity > oversellThreshold; // console.log('checkIfItemIsAllowedToOversell',{
            //   oversellThreshold,
            //   inventoryQuantity,
            //   inventoryPolicy,
            //   variantIsAllowedToOversell,
            // })

            return variantIsAllowedToOversell ? productOversellThreshold + inventoryQuantity : 0;
          },

          /**
           * Check if the cart item's variant is Non-inventory
           * 
           * @param {number} itemId 
           * @returns {number} - returns 99 stocks if item is a non-inventory otherwise 0
           */
          checkIfItemIsNonInventory: function checkIfItemIsNonInventory(item) {
            var delivery = item.delivery,
                locations = item.locations;
            var filteredLocations = locations.filter(function (loc) {
              return loc.available > 0;
            }); // Variant should be unavailable for both delivery and pickup to consider as non-inventory

            if (filteredLocations.length > 0 || delivery.available > 0) return false;

            var _window$itemsWithVari2 = window.itemsWithVariantInventoryData.find(function (_ref3) {
              var id = _ref3.id;
              return id === item.id;
            }),
                variant = _window$itemsWithVari2.variant;

            var oversell = this.checkIfItemIsAllowedToOversell(item.id);
            var nonInventory = variant.available && !oversell;
            return nonInventory ? 99 : 0;
          },
          availabilityMessages: function availabilityMessages(item) {
            var messages = [];
            var app = this;
            var delivery = item.delivery;
            var available = delivery.available;
            var inStock = delivery.inStock;
            var oversell = this.checkIfItemIsAllowedToOversell(item.id);
            var itemIsNonInventory = this.checkIfItemIsNonInventory(item);

            if (itemIsNonInventory) {
              inStock = true;
            } else if (available === 0) {
              available = oversell;
              inStock = oversell > 0;
            }

            var availableCondition = item.quantity <= available || itemIsNonInventory;
            messages.push("\n              <div class=\"" + (inStock ? availableCondition ? 'available' : 'low' : 'unavailable') + "\">\n                <p>" + (inStock ? availableCondition ? 'Available' : 'Not all items available' : 'Unavailable') + " for delivery</p>\n              </div>\n            "); // Oversell message condition for each delivery option

            if (oversell && (app.deliveryOption !== 'Delivery' && delivery.inStock === 0 || app.deliveryOption === 'Delivery' && delivery.inStock === true)) {
              messages.push("\n                <div class=\"available\">\n                  <p>" + (window.translations.product_stock.oversell_cart || '') + "</p>\n                </div>\n              ");
            } // Gift card availability message override


            if (item.gift_card === true && // line item is a gift card
            window.vars.gift_card_availability_message && ( // gift card availability message is enabled
            inStock || oversell) // is available or overselling
            ) {
                messages = ["\n                <div class=\"available\">\n                  <p>" + window.vars.gift_card_availability_message + "</p>\n                </div>\n              "];

                if (!availableCondition) {
                  messages.push("\n                  <div class=\"low\">\n                    <p>Not all items available for delivery</p>\n                  </div>\n                ");
                }
              }

            if (app.favStore && app.favStore.name) {
              // Gift card will always be unavailable for click & collect
              if (item.gift_card) {
                messages.push("\n                  <div class=\"unavailable\">\n                    <p>Unavailable for click & collect</p>\n                  </div>\n                ");
                return messages.join('');
              }

              var favStoreInventory = item.locations.find(function (obj) {
                return obj.name === app.favStore.name;
              });
              var ccMessage = "\n                <div class=\"" + (favStoreInventory.inStock ? item.quantity <= favStoreInventory.available ? 'available' : 'low' : 'unavailable') + "\">\n                  <p>\n                    " + (favStoreInventory.inStock ? item.quantity <= favStoreInventory.available ? 'Available' : 'Not all items available' : 'Unavailable') + " for click & collect\n                  </p>\n                </div>";
              if (favStoreInventory.excludedMessage) ccMessage = ccMessage.replace('Unavailable for click & collect', favStoreInventory.excludedMessage);
              messages.push(ccMessage);
            }

            return messages.join('');
          },
          cartModificationsMessage: function cartModificationsMessage() {
            var app = this;
            var items = app.$data.cart.items;
            var itemsToRemove = 0;
            var hasGiftCard = false;

            for (var i = items.length - 1; i >= 0; i--) {
              var item = items[i];
              var checkLoc = item.delivery;

              if (app.deliveryOption !== 'Delivery') {
                checkLoc = item.locations.find(function (obj) {
                  return obj.name === app.favStore.name;
                });
              }

              if (hasGiftCard === false) hasGiftCard = item.gift_card;

              if (checkLoc.inStock < 1 || app.deliveryOption !== 'Delivery' && item.gift_card === true) {
                itemsToRemove++;
              }
            }

            if (itemsToRemove > 0) {
              return itemsToRemove + " " + (itemsToRemove > 1 ? 'items' : 'item') + " \n                unavailable for " + app.deliveryOption + " will be removed from your cart \n                " + (hasGiftCard ? '<br/>' + window.translations.product_stock.giftcards_cart : '') + "\n              ";
            }

            return '';
          },
          productExclusionMessages: function productExclusionMessages() {
            var app = this;
            var items = app.$data.cart.items;

            if (app.deliveryOption === 'Delivery') {
              return '';
            }

            var favStoreLocs = items.map(function (i) {
              return i.locations;
            }).map(function (ls) {
              return ls.find(function (l) {
                return l.name === app.favStore.name;
              });
            }).filter(function (m) {
              return m !== undefined;
            });

            if (!(favStoreLocs && favStoreLocs.length > 0)) {
              return '';
            }

            var excludedMessages = favStoreLocs.map(function (l) {
              return l.excludedMessage;
            }).filter(function (m) {
              return m !== undefined;
            });

            var uniqueExcludedMessages = _toConsumableArray(new Set(excludedMessages));

            return uniqueExcludedMessages.join('<div class="cart_spacer"></div>');
          },
          prepareCart: function prepareCart(event) {
            var app = this;
            jQuery('#checkoutBtn').addClass("uloader utext-hide");

            if (app.override) {
              return true;
            }

            var updateCartPayload = {};

            for (var i = app.cart.items.length - 1; i >= 0; i--) {
              var item = app.cart.items[i];
              var currentMax = app.currentMax(item); // console.log('currentMax', currentMax, item.quantity)

              if (item.quantity > currentMax) {
                // instead of updating product quantity, simply remove the unavailable products instead of adding to the array to update quantities
                if (currentMax < 1) {
                  CartJS.removeItemById(item.variant_id);
                } else {
                  updateCartPayload[item.variant_id] = currentMax;
                }
              }
            }

            CartJS.updateItemQuantitiesById(updateCartPayload, {
              success: function success(data) {
                app.$data.override = true; // Update cart form DOM with updated cart data

                app.changeWholeData(supplementCart(data), 'cart'); // 3 seconds delay to make sure the DOM was updated with the new cart values before submitting the form to checkout

                setTimeout(function () {
                  // Trigger manual form submit
                  jQuery("#checkoutBtn").click();
                }, 3000);
              }
            });
            return false;
          },
          fakeCheckout: function fakeCheckout(event) {
            console.log('fakeCheckout', event);
            var app = this; // execute cart preparation (remove unavailable products if necessary)
            // For some reason we need this fake checkout button  and trigger button click submit via javascript code to make UFE work

            jQuery('#fake-checkoutBtn').addClass("uloader utext-hide");
            app.prepareCart(event);
          }
        }
      });
    } else if (window.vars.tomItLoaded > 1 && window.cartDisplay) {
      console.log('window.cartDisplay update');
      window.cartDisplay.cart = supplementCart(JSON.parse(JSON.stringify(cart)));
    }
  } catch (e) {
    console.error('cartDisplay Error', e);
  }

  jQuery('.de-u-fade').addClass('in');
  jQuery('#cartSpinner').addClass('de-u-hidden');
};

jQuery(document).on('cart.ready', function (event, cart) {
  cartInit = cart;
  tryInit();
});

if (window.clickCollectVersion === 'v1') {
  document.addEventListener('tomitLoaded', function () {
    return new Promise(function ($return, $error) {
      var _window, vars, tomitProductInventoryInfo, _window$tomitProductI, getProductsInventoryInformation, getVariantInventory, tomitCartPayload, tomitCartVariants, getVariantInventoryAndHandleErrors, inventoryInfo, missingInventoryVariants, inventoryInfoVariants, inventoryInfoVariantIDs, i, _variantInventory$pro, _inventoryProduct$pro, missingInventoryVariant, variantInventory, _Object$entries$, k, v, variantIndex, inventoryProductID, inventoryProduct, inventoryProductVariants;

      _window = window, vars = _window.vars, tomitProductInventoryInfo = _window.tomitProductInventoryInfo;
      _window$tomitProductI = window.tomitProductInventoryInfo, getProductsInventoryInformation = _window$tomitProductI.getProductsInventoryInformation, getVariantInventory = _window$tomitProductI.getVariantInventory;
      tomitCartPayload = vars.tomitCartPayload, tomitCartVariants = vars.tomitCartVariants;

      getVariantInventoryAndHandleErrors = function getVariantInventoryAndHandleErrors(vID) {
        return new Promise(function ($return, $error) {
          var response;

          var $Try_2_Post = function () {
            try {
              return $return(response);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          };

          var $Try_2_Catch = function (err) {
            try {
              console.error('Error getting inventory', err);
              response = undefined;
              return $Try_2_Post();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          };

          try {
            return Promise.resolve(getVariantInventory(vID)).then(function ($await_9) {
              try {
                response = $await_9;
                return $Try_2_Post();
              } catch ($boundEx) {
                return $Try_2_Catch($boundEx);
              }
            }, $Try_2_Catch);
          } catch (err) {
            $Try_2_Catch(err);
          }
        });
      };

      console.log('before inventoryInfo');
      console.log('tomitCartPayload', tomitCartPayload);

      var $Try_3_Post = function () {
        try {
          console.log('inventoryInfo', inventoryInfo);

          var $Try_4_Post = function () {
            try {
              console.log('inventoryInfo', inventoryInfo);
              invInit = inventoryInfo;
              window.vars.tomItLoaded += 1;
              tryInit();
              return $return();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          };

          var $Try_4_Catch = function (err) {
            try {
              console.error('Error getting variant inventories', err);
              return $Try_4_Post();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          };

          try {
            inventoryInfoVariants = Object.entries(inventoryInfo).map(function (_ref4) {
              var _v$product;

              var k = _ref4[0],
                  v = _ref4[1];
              return v == null ? void 0 : (_v$product = v.product) == null ? void 0 : _v$product.variants;
            });
            inventoryInfoVariantIDs = Object.entries(inventoryInfo).map(function (_ref5) {
              var _v$product2;

              var k = _ref5[0],
                  v = _ref5[1];
              return Object.keys(v == null ? void 0 : (_v$product2 = v.product) == null ? void 0 : _v$product2.variants);
            });
            inventoryInfoVariantIDs = inventoryInfoVariantIDs.reduce(function (acc, val) {
              return acc.concat(val);
            }, []); // console.log('tomitCartVariants', tomitCartVariants);

            missingInventoryVariants = tomitCartVariants.filter(function (vID) {
              return inventoryInfoVariantIDs.indexOf(String(vID)) === -1;
            }); // console.log('missingInventoryVariants', missingInventoryVariants);

            if (missingInventoryVariants.length > 0) {
              i = missingInventoryVariants.length - 1;
              var $Loop_7_trampoline;

              function $Loop_7_step() {
                i--;
                return $Loop_7;
              }

              function $Loop_7() {
                if (i >= 0) {
                  missingInventoryVariant = missingInventoryVariants[i];
                  return Promise.resolve(getVariantInventoryAndHandleErrors(missingInventoryVariant)).then(function ($await_10) {
                    try {
                      variantInventory = $await_10;

                      // console.log('variantInventory', variantInventory)
                      if (variantInventory === undefined) {
                        return $return();
                      }

                      _Object$entries$ = Object.entries(variantInventory == null ? void 0 : (_variantInventory$pro = variantInventory.product) == null ? void 0 : _variantInventory$pro.variants)[0], k = _Object$entries$[0], v = _Object$entries$[1];
                      variantIndex = tomitCartVariants.indexOf(parseInt(k));
                      inventoryProductID = tomitCartPayload[variantIndex];
                      inventoryProduct = inventoryInfo[String(inventoryProductID)];
                      inventoryProductVariants = inventoryProduct == null ? void 0 : (_inventoryProduct$pro = inventoryProduct.product) == null ? void 0 : _inventoryProduct$pro.variants;
                      inventoryProductVariants[k] = v;
                      return $Loop_7_step;
                    } catch ($boundEx) {
                      return $Try_4_Catch($boundEx);
                    }
                  }, $Try_4_Catch);
                } else return [1];
              }

              return ($Loop_7_trampoline = function (q) {
                while (q) {
                  if (q.then) return void q.then($Loop_7_trampoline, $Try_4_Catch);

                  try {
                    if (q.pop) {
                      if (q.length) return q.pop() ? $Loop_7_exit.call(this) : q;else q = $Loop_7_step;
                    } else q = q.call(this);
                  } catch (_exception) {
                    return $Try_4_Catch(_exception);
                  }
                }
              }.bind(this))($Loop_7);

              function $Loop_7_exit() {
                return $If_6.call(this);
              }
            }

            function $If_6() {
              return $Try_4_Post();
            }

            return $If_6.call(this);
          } catch (err) {
            $Try_4_Catch(err);
          }
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_3_Catch = function (e) {
        try {
          console.error('inventoryInfoError', e);
          return $Try_3_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(getProductsInventoryInformation(tomitCartPayload)).then(function ($await_11) {
          try {
            inventoryInfo = $await_11;
            return $Try_3_Post();
          } catch ($boundEx) {
            return $Try_3_Catch($boundEx);
          }
        }, $Try_3_Catch);
      } catch (e) {
        $Try_3_Catch(e);
      }
    });
  });
}

function tryInit() {
  if (window.clickCollectVersion === 'v1') {
    if (cartInit && invInit) {
      initCartDisplay(cartInit);
    }
  } else {
    if (cartInit) {
      initCartDisplay(cartInit);
    }
  }
}

jQuery(document).on('cart.requestComplete', function (event, cart) {
  try {
    console.log('cart.requestComplete');
    window.cartDisplay.changeWholeData(supplementCart(cart), 'cart');
    jQuery('.js-de-cart__subtotal').text(Shopify.formatMoney(cart.total_price));
    jQuery('.afterpay-info strong').text(Shopify.formatMoney(cart.total_price / 4));
    jQuery('#CartCount').text(cart.item_count);

    if (window.vars.thresholdForGateways.afterpay.enabled && window.vars.thresholdForGateways.afterpay.threshold && cart) {
      displayPaymentGateway(cart.total_price, window.vars.thresholdForGateways.afterpay.threshold * 100, 'afterpay');
    }

    if (window.vars.thresholdForGateways.zipPay.enabled && window.vars.thresholdForGateways.zipPay.threshold && cart) {
      displayPaymentGateway(cart.total_price, window.vars.thresholdForGateways.zipPay.threshold * 100, 'zip-pay');
    }
  } catch (error) {
    Rollbar.error('Cart update error', error);
  }
});

function displayPaymentGateway(price, threshold, gateway) {
  var dNoneClassName = 'de-u-hidden';
  jQuery(".cart-" + gateway + "-info").toggleClass(dNoneClassName, price < threshold);
  jQuery(".cart-" + gateway + "-disabled-info").toggleClass(dNoneClassName, price >= threshold);
}

document.addEventListener('DOMContentLoaded', function () {
  init();
});
